module.exports = __webpack_public_path__ + "64b049a3aea61a4dd115e16393fe8659.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_0_0.woff
// module id = 529
// module chunks = 0